/**
 * Map all possible values of aria-haspopup to an enum.
 *
 * @export
 * @enum {number}
 * @see {@link https://www.w3.org/TR/wai-aria/#aria-haspopup WAI-ARIA - aria-haspopup}
 */
var HasPopupValue;
(function (HasPopupValue) {
    HasPopupValue["FALSE"] = "false";
    HasPopupValue["TRUE"] = "true";
    HasPopupValue["MENU"] = "menu";
    HasPopupValue["LISTBOX"] = "listbox";
    HasPopupValue["TREE"] = "tree";
    HasPopupValue["GRID"] = "grid";
    HasPopupValue["DIALOG"] = "dialog";
})(HasPopupValue || (HasPopupValue = {}));

export { HasPopupValue as H };
